import { Asset, MetadataValue } from '@/api/generatedApi';
import { ActionIconButton } from '@/components/IconButton';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { usePopover } from '@/hooks/usePopover';
import { Add } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { MetadataForm } from './MetadataAddForm';
import { MetadataFieldDisplay } from './MetadataTableRow';

import { StyledPopover } from '@/components/AssetsPage/PopoverList';
import { AssetPageObjectModel } from '@/poms/assetPageObjectModel';

export const AddMetadataButton = ({
  asset,
  onMetadataChange,
  formattedMetadata,
}: {
  asset: Asset;
  onMetadataChange: (newMetadata: Record<string, MetadataValue>) => void;
  formattedMetadata: MetadataFieldDisplay[];
}) => {
  const { permissions } = useGetCurrentUser();
  const { open: handleAddClick, close: handleAddClose, isOpen: addOpen, anchorElement } = usePopover();

  const handleAddSuccess = (newMetadata: Record<string, MetadataValue>) => {
    handleAddClose();
    onMetadataChange(newMetadata);
  };

  if (!permissions.canModifyAssetMetadata) {
    return;
  }

  return (
    <Box>
      <ActionIconButton
        enableShadow={formattedMetadata.length > 0}
        onClick={handleAddClick}
        data-testid={AssetPageObjectModel.AddMetadataButton}
      >
        <Tooltip title='Add Metadata'>
          <Add sx={{ fontSize: '18px' }} />
        </Tooltip>
      </ActionIconButton>

      <StyledPopover
        open={addOpen}
        anchorEl={anchorElement}
        onClose={handleAddClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              marginLeft: '2px',
              marginTop: '4px',
              borderRadius: '12px',
            },
          },
        }}
      >
        <MetadataForm asset={asset} onSuccess={handleAddSuccess} onCancel={handleAddClose} />
      </StyledPopover>
    </Box>
  );
};
